export const translations = {
  en: {
    nav: { home: "Home", about: "About", academics: "Academics", contact: "Contact" },
    common: {
      schoolName: "Sathya Matriculation Higher Secondary School",
      schoolShort: "SMHSS",
      motto: "Learn • Love • Serve",
      mottoWords: ["Learn", "Love", "Serve"],
      estLine: "Est. 1989 — Valasaravakkam, Chennai",
      society: "A Unit of Vaishnavi Educational Society",
      regd: "Regd. No. 254 / 1989",
      addressLines: ["No. 100, S. V. S Nagar, Annexe,", "Valasaravakkam, Chennai, Tamil Nadu – 600087"],
      landline: "Landline",
      mobile: "Mobile / WhatsApp",
      email: "Email",
      callSchool: "Call School",
      whatsapp: "WhatsApp",
      emailUs: "Email Us",
      directions: "Get Directions",
      discover: "Discover SMHSS",
      contactUs: "Contact Us",
      learnMore: "Learn More",
      call: "Call",
    },
    hero: {
      eyebrow: "Educating generations since 1989",
      since: "Educating generations since 1989.",
      sub: "Holistic education, individual attention and academic excellence — from LKG to 12th Standard, in the heart of Valasaravakkam.",
    },
    marquee: ["Learn", "Love", "Serve", "Since 1989", "SMHSS Chennai"],
    facts: [
      { label: "Established", value: "1989" },
      { label: "Classes", value: "LKG – 12th Std" },
      { label: "Pre-KG", value: "Coming Soon" },
      { label: "Medium", value: "English" },
      { label: "Type", value: "Co-educational" },
      { label: "Board", value: "Matriculation" },
    ],
    home: {
      introEyebrow: "Our School",
      introTitle: "An established Chennai school, with history and heart.",
      introBody: "Sathya Matriculation Higher Secondary School is an English-medium, co-educational Matriculation school in Valasaravakkam, Chennai. Since 1989, we have educated students from LKG through 12th Standard — with individual attention, discipline and genuine care guiding every classroom.",
      philosophyEyebrow: "Our Philosophy",
      philosophyTitle: "Three words that shape every day.",
      philosophyIntro: "Our motto is not a slogan — it is the framework for holistic education, personal development and respect for others.",
      academicsEyebrow: "Academics",
      academicsTitle: "A complete journey, from first steps to 12th Standard.",
      academicsBody: "Matriculation education in English medium, thoughtfully structured from Kindergarten to Higher Secondary — with Pre-KG arriving soon.",
      academicsCta: "Explore Academics",
      legacyEyebrow: "Our Legacy",
      legacyTitle: "A school born of love, built for generations.",
      legacyBody: "SMHSS was established in 1989 in memory of S. Sathyanarayanan. His parents, the late G. Srinivasan and Puliyur Saroja, transformed a deeply personal loss into an enduring commitment to education and service.",
      legacyCta: "Read Our Story",
      campusEyebrow: "Our Campus",
      campusTitle: "Where learning lives.",
      campusBody: "A green, welcoming campus in the heart of Valasaravakkam — classrooms, courtyards and quiet corners for growing minds.",
      visitEyebrow: "Visit Us",
      visitTitle: "We would love to welcome you.",
      visitBody: "Come and see the school, meet our teachers and experience the warmth of SMHSS for yourself.",
    },
    philosophy: [
      { word: "Learn", num: "01", body: "Strong academic foundations, curiosity and the confidence to progress — knowledge that carries students through every stage of their education." },
      { word: "Love", num: "02", body: "An environment founded on care, respect, compassion and consideration for others — where every child is known and valued." },
      { word: "Serve", num: "03", body: "Responsibility, character and a willingness to contribute positively to the community — values that last a lifetime." },
    ],
    journey: [
      { stage: "Pre-KG", level: "Coming Soon", soon: true },
      { stage: "LKG & UKG", level: "Kindergarten" },
      { stage: "Standards 1 – 5", level: "Primary" },
      { stage: "Standards 6 – 10", level: "Secondary" },
      { stage: "Standards 11 – 12", level: "Higher Secondary" },
    ],
    gallery: [
      { key: "building", caption: "The school building" },
      { key: "courtyard", caption: "The courtyard" },
      { key: "classroom", caption: "A classroom" },
      { key: "library", caption: "Library & meeting room" },
      { key: "corridor", caption: "The entrance corridor" },
    ],
    about: {
      title: "About SMHSS",
      sub: "An English-medium, co-educational Matriculation school — established 1989, Valasaravakkam, Chennai.",
      schoolEyebrow: "Our School",
      schoolTitle: "Educating Valasaravakkam since 1989.",
      schoolBody1: "Sathya Matriculation Higher Secondary School is an English-medium, co-educational Matriculation school established in 1989 in Valasaravakkam, Chennai, educating students from LKG through 12th Standard.",
      schoolBody2: "For over three decades, the school has stood for holistic education, individual attention, academic excellence, discipline and personal development — with respect for others at the heart of everything we do.",
      resultsLine: "The school is proud of its excellent academic results and its commitment to supporting each student throughout their educational journey.",
      storyEyebrow: "Our Story",
      storyTitle: "In memory of S. Sathyanarayanan.",
      storyP1: "Sathya Matriculation Higher Secondary School was established in 1989 in memory of S. Sathyanarayanan, whose life was tragically cut short in an accident.",
      storyP2: "His parents, the late G. Srinivasan and Puliyur Saroja, founded the school in his memory — transforming a deeply personal loss into an enduring commitment to education and service.",
      storyP3: "That commitment continues to guide the school today. Every generation of students carries forward a legacy built on love, purpose and service.",
      philEyebrow: "Our Philosophy",
      philTitle: "Learn • Love • Serve",
      philBody: "Our motto is the framework for everything we do — building strong academic foundations, creating an environment of care and respect, and encouraging students to contribute positively to their community.",
      leadershipEyebrow: "Leadership",
      leadershipTitle: "Guided with care.",
      chairperson: "Chairperson",
      chairpersonName: "Puliyur Saroja",
      chairpersonNote: "Founder and guiding presence of the school since 1989.",
      principal: "Principal",
      principalName: "R. Sivakumar",
      principalNote: "Leading the school's academic and personal development mission.",
      membersTitle: "Vaishnavi Educational Society Members",
      members: [
        { name: "S. Saroja", role: "Chairperson" },
        { name: "B. S. Radhakrishnan", role: "Vice Chairman" },
        { name: "R. Rajalakshmi", role: "Treasurer" },
        { name: "R. Pranava Kumara Guru", role: "Secretary" },
        { name: "R. Sivakumar", role: "Principal & Ex Officio Member" },
        { name: "S. Balasubramanian", role: "Member" },
        { name: "Praveen", role: "Member" },
      ],
      societyEyebrow: "Our Foundation",
      societyTitle: "Vaishnavi Educational Society",
      societyBody: "Sathya Matriculation Higher Secondary School is a unit of Vaishnavi Educational Society, Regd. No. 254 / 1989.",
    },
    academics: {
      title: "Academics",
      sub: "Matriculation education in English medium — a clear, complete journey from Kindergarten to Higher Secondary.",
      pillars: [
        { title: "Matriculation Education", body: "A structured Matriculation curriculum guiding students from their earliest years through 12th Standard." },
        { title: "English Medium", body: "Instruction in English throughout, building strong language foundations from Kindergarten onwards." },
        { title: "Co-educational", body: "Boys and girls learning together in an environment of mutual respect and shared growth." },
      ],
      journeyEyebrow: "The Academic Journey",
      journeyTitle: "Every stage, thoughtfully guided.",
      journeyIntro: "From the first days of Kindergarten to the final years of Higher Secondary, each stage of the journey receives individual attention and care.",
      note: "Detailed subject and curriculum information will be published here soon. For admissions and academic enquiries, please contact the school office.",
      noteCta: "Contact the Office",
    },
    contact: {
      title: "Contact Us",
      sub: "We are always happy to hear from parents and visitors. Reach us by phone, WhatsApp or email — or visit the campus.",
      reachEyebrow: "Reach Us",
      addressTitle: "Our Address",
      actionsTitle: "Quick Actions",
      mapEyebrow: "Find Us",
      mapTitle: "Visit the campus",
      officeNote: "School office hours: Monday to Saturday, during working hours.",
    },
    footer: {
      tagline: "Educating generations since 1989 — with holistic education, individual attention and academic excellence.",
      quickLinks: "Quick Links",
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
  },

  ta: {
    nav: { home: "முகப்பு", about: "எங்களைப் பற்றி", academics: "கல்வி", contact: "தொடர்பு" },
    common: {
      schoolName: "சத்யா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி",
      schoolShort: "SMHSS",
      motto: "கற்றல் • அன்பு • சேவை",
      mottoWords: ["கற்றல்", "அன்பு", "சேவை"],
      estLine: "நிறுவப்பட்டது 1989 — வளசரவாக்கம், சென்னை",
      society: "வைஷ்ணவி கல்விச் சங்கத்தின் ஓர் அங்கம்",
      regd: "பதிவு எண். 254 / 1989",
      addressLines: ["எண் 100, எஸ்.வி.எஸ். நகர் அனெக்ஸ்,", "வளசரவாக்கம், சென்னை, தமிழ்நாடு – 600087"],
      landline: "தொலைபேசி",
      mobile: "அலைபேசி / வாட்ஸ்அப்",
      email: "மின்னஞ்சல்",
      callSchool: "பள்ளியை அழைக்க",
      whatsapp: "வாட்ஸ்அப்",
      emailUs: "மின்னஞ்சல் அனுப்ப",
      directions: "வழிகாட்டுதல் பெற",
      discover: "SMHSS-ஐ அறியுங்கள்",
      contactUs: "தொடர்பு கொள்ளுங்கள்",
      learnMore: "மேலும் அறிய",
      call: "அழைக்க",
    },
    hero: {
      eyebrow: "1989 முதல் தலைமுறைகளுக்குக் கல்வி",
      since: "1989 முதல் தலைமுறைகளுக்குக் கல்வி வழங்கி வருகிறோம்.",
      sub: "முழுமையான கல்வி, தனிக்கவனம், கல்விச் சிறப்பு — எல்.கே.ஜி முதல் 12ஆம் வகுப்பு வரை, வளசரவாக்கத்தின் இதயத்தில்.",
    },
    marquee: ["கற்றல்", "அன்பு", "சேவை", "1989 முதல்", "SMHSS சென்னை"],
    facts: [
      { label: "நிறுவப்பட்டது", value: "1989" },
      { label: "வகுப்புகள்", value: "எல்.கே.ஜி – 12ஆம் வகுப்பு" },
      { label: "ப்ரீ-கேஜி", value: "விரைவில்" },
      { label: "பயிற்றுமொழி", value: "ஆங்கிலம்" },
      { label: "வகை", value: "இணைக்கல்வி" },
      { label: "பாடத்திட்டம்", value: "மெட்ரிகுலேஷன்" },
    ],
    home: {
      introEyebrow: "எங்கள் பள்ளி",
      introTitle: "வரலாறும் அன்பும் கொண்ட, சென்னையின் நிலைபெற்ற பள்ளி.",
      introBody: "சத்யா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி, சென்னை வளசரவாக்கத்தில் அமைந்த ஆங்கில வழி இணைக்கல்வி மெட்ரிகுலேஷன் பள்ளியாகும். 1989 முதல், எல்.கே.ஜி முதல் 12ஆம் வகுப்பு வரை — தனிக்கவனம், ஒழுக்கம், உண்மையான அக்கறையுடன் கல்வி வழங்கி வருகிறோம்.",
      philosophyEyebrow: "எங்கள் தத்துவம்",
      philosophyTitle: "ஒவ்வொரு நாளையும் வடிவமைக்கும் மூன்று சொற்கள்.",
      philosophyIntro: "எங்கள் குறிக்கோள் வெறும் வாசகம் அல்ல — முழுமையான கல்வி, ஆளுமை வளர்ச்சி, பிறரை மதித்தல் ஆகியவற்றின் அடிப்படைச் சட்டகம்.",
      academicsEyebrow: "கல்வி",
      academicsTitle: "முதல் அடி முதல் 12ஆம் வகுப்பு வரை — முழுமையான பயணம்.",
      academicsBody: "மழலையர் நிலை முதல் மேல்நிலை வரை சீராக வடிவமைக்கப்பட்ட ஆங்கில வழி மெட்ரிகுலேஷன் கல்வி — விரைவில் ப்ரீ-கேஜி வகுப்பும்.",
      academicsCta: "கல்வி விவரங்கள்",
      legacyEyebrow: "எங்கள் மரபு",
      legacyTitle: "அன்பில் பிறந்து, தலைமுறைகளுக்காக கட்டமைக்கப்பட்ட பள்ளி.",
      legacyBody: "எஸ். சத்யநாராயணன் அவர்களின் நினைவாக 1989இல் SMHSS நிறுவப்பட்டது. அவரது பெற்றோர் — மறைந்த ஜி. சீனிவாசன் மற்றும் புலியூர் சரோஜா — ஆழ்ந்த தனிப்பட்ட இழப்பை, கல்விக்கும் சேவைக்குமான நிலையான அர்ப்பணிப்பாக மாற்றினர்.",
      legacyCta: "எங்கள் கதையை அறிய",
      campusEyebrow: "எங்கள் வளாகம்",
      campusTitle: "கற்றல் வாழும் இடம்.",
      campusBody: "வளசரவாக்கத்தின் இதயத்தில் பசுமையான, அன்பான வளாகம் — வளரும் மனங்களுக்கான வகுப்பறைகள், முற்றங்கள், அமைதியான இடங்கள்.",
      visitEyebrow: "எங்களை வந்து பாருங்கள்",
      visitTitle: "உங்களை வரவேற்க ஆவலாக உள்ளோம்.",
      visitBody: "பள்ளிக்கு வருகை தந்து, ஆசிரியர்களைச் சந்தித்து, SMHSS-இன் அன்பான சூழலை நேரில் உணருங்கள்.",
    },
    philosophy: [
      { word: "கற்றல்", num: "01", body: "உறுதியான கல்வி அடித்தளங்கள், ஆர்வம், முன்னேறும் நம்பிக்கை — கல்விப் பயணத்தின் ஒவ்வொரு நிலையிலும் துணை நிற்கும் அறிவு." },
      { word: "அன்பு", num: "02", body: "அக்கறை, மரியாதை, கருணை, பிறரைப் பேணுதல் ஆகியவற்றின் அடிப்படையில் அமைந்த சூழல் — ஒவ்வொரு குழந்தையும் அறியப்பட்டு மதிக்கப்படும் இடம்." },
      { word: "சேவை", num: "03", body: "பொறுப்புணர்வு, நற்பண்பு, சமூகத்திற்கு நன்மை செய்யும் மனப்பான்மை — வாழ்நாள் முழுவதும் நிலைத்திருக்கும் விழுமியங்கள்." },
    ],
    journey: [
      { stage: "ப்ரீ-கேஜி", level: "விரைவில்", soon: true },
      { stage: "எல்.கே.ஜி & யூ.கே.ஜி", level: "மழலையர் நிலை" },
      { stage: "வகுப்புகள் 1 – 5", level: "தொடக்கக் கல்வி" },
      { stage: "வகுப்புகள் 6 – 10", level: "உயர்நிலைக் கல்வி" },
      { stage: "வகுப்புகள் 11 – 12", level: "மேல்நிலைக் கல்வி" },
    ],
    gallery: [
      { key: "building", caption: "பள்ளிக் கட்டடம்" },
      { key: "courtyard", caption: "முற்றம்" },
      { key: "classroom", caption: "வகுப்பறை" },
      { key: "library", caption: "நூலகம் & கூட்ட அறை" },
      { key: "corridor", caption: "நுழைவு நடைபாதை" },
    ],
    about: {
      title: "எங்களைப் பற்றி",
      sub: "ஆங்கில வழி, இணைக்கல்வி மெட்ரிகுலேஷன் பள்ளி — 1989இல் நிறுவப்பட்டது, வளசரவாக்கம், சென்னை.",
      schoolEyebrow: "எங்கள் பள்ளி",
      schoolTitle: "1989 முதல் வளசரவாக்கத்திற்குக் கல்வி.",
      schoolBody1: "சத்யா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி, 1989இல் சென்னை வளசரவாக்கத்தில் நிறுவப்பட்ட ஆங்கில வழி இணைக்கல்வி மெட்ரிகுலேஷன் பள்ளியாகும். எல்.கே.ஜி முதல் 12ஆம் வகுப்பு வரை மாணவர்களுக்குக் கல்வி வழங்கி வருகிறது.",
      schoolBody2: "மூன்று தசாப்தங்களுக்கும் மேலாக, முழுமையான கல்வி, தனிக்கவனம், கல்விச் சிறப்பு, ஒழுக்கம், ஆளுமை வளர்ச்சி — இவற்றுடன் பிறரை மதித்தலை மையமாகக் கொண்டு பள்ளி செயல்பட்டு வருகிறது.",
      resultsLine: "சிறந்த கல்வி முடிவுகளிலும், ஒவ்வொரு மாணவரின் கல்விப் பயணம் முழுவதும் துணை நிற்பதிலும் பள்ளி பெருமை கொள்கிறது.",
      storyEyebrow: "எங்கள் கதை",
      storyTitle: "எஸ். சத்யநாராயணன் நினைவாக.",
      storyP1: "விபத்தில் அகால மரணமடைந்த எஸ். சத்யநாராயணன் அவர்களின் நினைவாக, 1989இல் சத்யா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி நிறுவப்பட்டது.",
      storyP2: "அவரது பெற்றோர் — மறைந்த ஜி. சீனிவாசன் மற்றும் புலியூர் சரோஜா — தங்கள் மகனின் நினைவாக இப்பள்ளியை நிறுவி, ஆழ்ந்த தனிப்பட்ட இழப்பை கல்விக்கும் சேவைக்குமான நிலையான அர்ப்பணிப்பாக மாற்றினர்.",
      storyP3: "அந்த அர்ப்பணிப்பு இன்றும் பள்ளியை வழிநடத்துகிறது. ஒவ்வொரு தலைமுறை மாணவர்களும் அன்பு, நோக்கம், சேவை ஆகியவற்றால் கட்டமைக்கப்பட்ட மரபை முன்னெடுத்துச் செல்கின்றனர்.",
      philEyebrow: "எங்கள் தத்துவம்",
      philTitle: "கற்றல் • அன்பு • சேவை",
      philBody: "எங்கள் குறிக்கோளே எங்கள் அனைத்து செயல்பாடுகளின் அடிப்படை — உறுதியான கல்வி அடித்தளங்களை உருவாக்குதல், அக்கறையும் மரியாதையும் நிறைந்த சூழலை அமைத்தல், சமூகத்திற்கு நன்மை செய்ய மாணவர்களை ஊக்குவித்தல்.",
      leadershipEyebrow: "தலைமை",
      leadershipTitle: "அக்கறையுடன் வழிநடத்தல்.",
      chairperson: "தலைவர்",
      chairpersonName: "புலியூர் சரோஜா",
      chairpersonNote: "1989 முதல் பள்ளியின் நிறுவனரும் வழிகாட்டியும்.",
      principal: "முதல்வர்",
      principalName: "ஆர். சிவகுமார்",
      principalNote: "பள்ளியின் கல்வி மற்றும் ஆளுமை வளர்ச்சிப் பணியை வழிநடத்துகிறார்.",
      membersTitle: "வைஷ்ணவி கல்விச் சங்க உறுப்பினர்கள்",
      members: [
        { name: "எஸ். சரோஜா", role: "தலைவர்" },
        { name: "பி.எஸ். ராதாகிருஷ்ணன்", role: "துணைத் தலைவர்" },
        { name: "ஆர். ராஜலட்சுமி", role: "பொருளாளர்" },
        { name: "ஆர். பிரணவ குமார குரு", role: "செயலாளர்" },
        { name: "ஆர். சிவகுமார்", role: "முதல்வர் & பதவி வழி உறுப்பினர்" },
        { name: "எஸ். பாலசுப்ரமணியன்", role: "உறுப்பினர்" },
        { name: "பிரவீன்", role: "உறுப்பினர்" },
      ],
      societyEyebrow: "எங்கள் அடித்தளம்",
      societyTitle: "வைஷ்ணவி கல்விச் சங்கம்",
      societyBody: "சத்யா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி, வைஷ்ணவி கல்விச் சங்கத்தின் ஓர் அங்கமாகும் — பதிவு எண். 254 / 1989.",
    },
    academics: {
      title: "கல்வி",
      sub: "ஆங்கில வழி மெட்ரிகுலேஷன் கல்வி — மழலையர் நிலை முதல் மேல்நிலை வரை தெளிவான, முழுமையான பயணம்.",
      pillars: [
        { title: "மெட்ரிகுலேஷன் கல்வி", body: "தொடக்கம் முதல் 12ஆம் வகுப்பு வரை மாணவர்களை வழிநடத்தும் சீரான மெட்ரிகுலேஷன் பாடத்திட்டம்." },
        { title: "ஆங்கில வழிக் கல்வி", body: "மழலையர் நிலை முதலே உறுதியான மொழி அடித்தளங்களை உருவாக்கும் ஆங்கில வழி பயிற்றுமுறை." },
        { title: "இணைக்கல்வி", body: "பரஸ்பர மரியாதையும் இணைந்த வளர்ச்சியும் நிறைந்த சூழலில் ஆண், பெண் மாணவர்கள் ஒன்றாகக் கற்கின்றனர்." },
      ],
      journeyEyebrow: "கல்விப் பயணம்",
      journeyTitle: "ஒவ்வொரு நிலையும், அக்கறையுடன்.",
      journeyIntro: "மழலையர் நிலையின் முதல் நாட்கள் முதல் மேல்நிலை இறுதி ஆண்டுகள் வரை — ஒவ்வொரு நிலையிலும் தனிக்கவனமும் அக்கறையும்.",
      note: "பாடங்கள் மற்றும் பாடத்திட்ட விவரங்கள் விரைவில் இங்கு வெளியிடப்படும். சேர்க்கை மற்றும் கல்வி தொடர்பான விசாரணைகளுக்கு பள்ளி அலுவலகத்தைத் தொடர்பு கொள்ளவும்.",
      noteCta: "அலுவலகத்தைத் தொடர்பு கொள்ள",
    },
    contact: {
      title: "தொடர்பு கொள்ள",
      sub: "பெற்றோர்களிடமிருந்தும் பார்வையாளர்களிடமிருந்தும் கேட்பதில் எப்போதும் மகிழ்ச்சி. தொலைபேசி, வாட்ஸ்அப், மின்னஞ்சல் வழியாகவோ — நேரில் வந்தோ — எங்களை அணுகுங்கள்.",
      reachEyebrow: "எங்களை அணுக",
      addressTitle: "எங்கள் முகவரி",
      actionsTitle: "விரைவு செயல்கள்",
      mapEyebrow: "எங்களைக் கண்டறிய",
      mapTitle: "வளாகத்திற்கு வருகை தாருங்கள்",
      officeNote: "பள்ளி அலுவலக நேரம்: திங்கள் முதல் சனி வரை, பணி நேரங்களில்.",
    },
    footer: {
      tagline: "1989 முதல் தலைமுறைகளுக்குக் கல்வி — முழுமையான கல்வி, தனிக்கவனம், கல்விச் சிறப்புடன்.",
      quickLinks: "விரைவு இணைப்புகள்",
      contactTitle: "தொடர்பு",
      rights: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    },
  },
};
